"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToActionReserveOrOrder() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section ref={ref} className="relative bg-accent-dark py-16 md:py-24 overflow-hidden">
      <div className={`container mx-auto px-6 max-w-4xl text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-white mb-4">
          Experience Authentic Mexican Flavor
        </h2>
        <p className="text-base md:text-lg text-white mb-8 max-w-2xl mx-auto">
          Join us for a memorable dining experience with sizzling fajitas, fresh
          tacos, and signature margaritas. Whether dining in or ordering out,
          we're ready to serve you.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-lg bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.02] hover:shadow-medium active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            <Link to="/ContactPage">Reserve a Table</Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto rounded-lg bg-background text-foreground border-2 border-accent hover:bg-accent/10 hover:scale-[1.02] hover:shadow-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            <Link to="https://online.skytab.com/s/texasmargaritascarmeltakeout">Order Takeout</Link>
          </Button>
        </div>
      </div>
    </section>;
}